module.exports = __webpack_public_path__ + "static/images/62f38a71.png";